import IframeResizer from 'iframe-resizer-react';

export const FeedbackPage = () => (
    <div className='padding-20'>
        <IframeResizer
            src='https://contact-form.rio.cloud/contact?opener=https%3A%2F%2Frental.logistic-network.rio.cloud%2F'
            checkOrigin={false}
            className='unstyled min-width-100pct'
            style={{ height: '600px' }}
        />
    </div>
);
